<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="form"
    (cancel)="cancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$">
        <form [formGroup]="form">
          <div
            class="row"
            *ngIf="
              isNewDiaryNote
                | diaryNoteDisplayCreatedDate : data.content.createdDate
            ">
            <div class="col">
              <lds-date-input
                formControlName="createdDate"
                label="Created date"
                [isReadOnly]="true">
              </lds-date-input>
            </div>
          </div>
          
          <!-- Summary section with aggregator-specific layout -->
          <agp-shared-aggregator-wrapper>
            <ng-template agpSharedAggregator="mpm">
              <div class="row">
                <div class="col-9">
                  <lds-text-input
                    formControlName="summary"
                    label="Summary"
                    placeholder="short summary"
                    [maxlength]="128"
                    [isRequired]="data.schema.summary | sharedRequirement"
                    [validations]="{
                      required: 'Please provide a summary'
                    }">
                  </lds-text-input>
                </div>
                <div class="col-3 mt-lg">
                  <lds-checkbox formControlName="submit" label="Submit to lender">
                  </lds-checkbox>
                </div>
              </div>
            </ng-template>
            <ng-template agpSharedAggregatorDefault>
              <div class="row">
                <div class="col">
                  <lds-text-input
                    formControlName="summary"
                    label="Summary"
                    placeholder="short summary"
                    [maxlength]="128"
                    [isRequired]="data.schema.summary | sharedRequirement"
                    [validations]="{
                      required: 'Please provide a summary'
                    }">
                  </lds-text-input>
                </div>
              </div>
            </ng-template>
          </agp-shared-aggregator-wrapper>
          
          <div class="row">
            <div class="col">
              <lds-text-area
                formControlName="details"
                label="Details"
                placeholder="note details"
                [rows]="10"
                [maxlength]="4000"
                [showRemaining]="true"
                [expandable]="true"
                [isRequired]="data.schema.details | sharedRequirement"
                [validations]="{
                  required: 'Please provide details'
                }">
              </lds-text-area>
            </div>
          </div>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
